import React from 'react';
import { Text } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import Header from '@/components/Header';

export default function HomeScreen() {
  return (
    <SafeAreaView style={{flex: 1}}>
      <Header />
      <Text>Hello Web Index (tabs)!</Text>
    </SafeAreaView>
  );
}
